export const EMAIL_OTP_REQUEST_MINUTES = 3;

export const LOGIN_TYPE = {
    learner: 'Learner',
    administrator: 'Administrator'
};

export const TABLE_CONST = {
    DEFAULT_PER_PAGE: 10
};

export const quizCategoryColors = {
    learning: '#efd66f',
    reading: '#ed6dad',
    writing: '#4ea9cb',
    oralcommunication: '#a469d1',
    numeracy: '#19a65b'
};

export const quizIds = ['acsf3', 'acsf4', 'vfh', 'acsf3shortcourse'];

// for date locale for date format purpose
export const DATE_FORMAT_LOCALE = 'en-AU';

export const TEST_LEVEL_LABEL = {
    acsf3: 'ACSF 3',
    acsf4: 'ACSF 4',
    vfh: 'VSL',
    acsf3shortcourse: 'ACSF3 Short Course'
};

export const QUALIFICATION_LEVEL_NAMES = {
    1: 'Certificate I',
    2: 'Certificate II',
    3: 'Certificate III',
    4: 'Certificate IV',
    5: 'Diploma',
    6: 'Advanced Diploma +'
};
export const DLRQ_SUITABILITY = [
    {
        title: 'Unsuitable',
        description: 'This training approach is not suitable for the candidate',
        color: '#FFF',
        backgroundColor: '#BE000F'
    },
    {
        title: 'Support Required',
        description: 'This training approach should be suitable for the candidate with support from the RTO',
        color: '',
        backgroundColor: '#FEBF28'
    },
    {
        title: 'Suitable',
        description: 'This training approach will not present any issues to the candidate',
        color: '',
        backgroundColor: '#10B053'
    }
];

/* The titles will need to be updated in the SVG if they change */
export const dlrqFocusAreas = [
    { name: 'digital', title: 'Information and Data Literacy' },
    { name: 'communication', title: 'Communication and Collaboration' },
    { name: 'content', title: 'Digital Content Creation' },
    { name: 'protection', title: 'Protection and Safety' },
    { name: 'technical', title: 'Technical Proficiency and Problem Solving' }
];

export const dlrqFocusAreaColors = [
    { primary: '#92d050', label: '#000', score: '#c0e399' },
    { primary: '#7030a0', label: '#fff', score: '#aa72d4' },
    { primary: '#ff0066', label: '#fff', score: '#ff75ad' },
    { primary: '#ff6600', label: '#fff', score: '#ffaf79' },
    { primary: '#cc9900', label: '#fff', score: '#ffde81' }
];

export const skills = ['learning', 'reading', 'writing', 'oralcommunication', 'numeracy'];

export const skillNames = {
    learning: 'Learning',
    reading: 'Reading',
    writing: 'Writing',
    oralcommunication: 'Oral Communication',
    numeracy: 'Numeracy'
};

/**
 * suitability of online training table
 * capability, index
 * dlrqSuitabilityTable[capability][index]
 */
const SUITABILITY_DESCRIPTION = [
    'The results of the questionnaire indicate that the candidate will not be able to engage in online learning with the RTO',
    'The results of the questionnaire indicate that the candidate should be able to engage in online learning with the RTO, however some assistance relating to digital capability may be required.',
    'The results of the questionnaire indicate that the candidate should be able to engage in online learning with the RTO, however some assistance relating to digital capability or accessing the training may be required.',
    'The results of the questionnaire indicate that the candidate will be able to engage in online learning with the RTO',
    'The results of the questionnaire indicate that the candidate should be able to engage in online learning with the RTO, however some assistance relating to accessing the training may be required.'
];

export const DLRQ_SUITABILITY_TABLE = [
    [],
    [
        'N/A',
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[1]
    ],
    [
        'N/A',
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[2],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[1]
    ],
    [
        'N/A',
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[2],
        SUITABILITY_DESCRIPTION[2],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[1],
        SUITABILITY_DESCRIPTION[3]
    ],
    [
        'N/A',
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[0],
        SUITABILITY_DESCRIPTION[2],
        SUITABILITY_DESCRIPTION[2],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3]
    ],
    [
        'N/A',
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3]
    ],
    [
        'N/A',
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3]
    ],
    [
        'N/A',
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3]
    ],
    [
        'N/A',
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[4],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3],
        SUITABILITY_DESCRIPTION[3]
    ]
];

export const DLRQ_FOCUS_AREAS = [
    {
        key: 'digital',
        label: 'Information and Data Literacy',
        color: { primary: '#92d050', label: '#000', score: '#c0e399' }
    },
    {
        key: 'communication',
        label: 'Communication and Collaboration',
        color: { primary: '#7030a0', label: '#fff', score: '#aa72d4' }
    },
    {
        key: 'content',
        label: 'Digital Content Creation',
        color: { primary: '#ff0066', label: '#fff', score: '#ff75ad' }
    },
    {
        key: 'protection',
        label: 'Protection and Safety',
        color: { primary: '#ff6600', label: '#fff', score: '#ffaf79' }
    },
    {
        key: 'technical',
        label: 'Technical Proficiency and Problem Solving',
        color: { primary: '#cc9900', label: '#fff', score: '#ffde81' }
    }
];

export const QUESTION_CATEGORIES = [
    {
        key: 'learning',
        label: 'Learning'
    },
    {
        key: 'reading',
        label: 'Reading'
    },
    {
        key: 'writing',
        label: 'Writing'
    },
    {
        key: 'oralcommunication',
        label: 'Oral Communication'
    },
    {
        key: 'numeracy',
        label: 'Numeracy'
    }
];

// for LLN Profile SKills Per Quiz Type
export const PROFILE_SKILLS_PER_QUIZ = {
    acsf3: ['learning', 'reading', 'writing', 'oralcommunication', 'numeracy'],
    acsf4: ['learning', 'reading', 'writing', 'oralcommunication', 'numeracy'],
    acsf3shortcourse: ['reading', 'writing', 'numeracy'],
    vfh: ['reading', 'numeracy']
};

export const MONTH_NAMES = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export const DEFAULT_FORM_LIST = [
    {
        label: 'Learner ID',
        fieldtype: 'text',
        validation: { required: false },
        isDefault: true
    },
    {
        label: 'First Name',
        fieldtype: 'text',
        validation: { required: true },
        isDefault: true
    },
    {
        label: 'Last Name',
        fieldtype: 'text',
        validation: { required: true },
        isDefault: true
    },
    {
        label: 'Email',
        fieldtype: 'text',
        validation: { required: true },
        isDefault: true
    }
];

export const EMAIL_TEMPLATES = {
    learnerInvite: {
        templateKey: 'ACSF',
        label: 'ACSF Learner Invite',
        isDLRQ: false,
        subject: 'Quiz for your enrolment at <variable>displayName</variable> ',
        body: '<p>Dear <variable>learnerFirstName</variable>,</p><p>As part of your course enrolment at <variable>displayName</variable> we would like you to complete a short online quiz so we can understand your current levels of language, literacy and numeracy and then, if required, tailor your training to suit your needs.</p><p>Please click on the link below to start the online quiz:</p><p><variable>linkToQuiz</variable> </p><p>If the above link does not work please copy and paste this URL into your Internet browser: <variable>plainLinkToQuiz</variable> </p><p>Note: Please access the Quiz using the latest version of Google Chrome.</p><p>If you have any questions please email <variable>learnerCorrespondenceEmail</variable> and someone will respond as soon as possible.</p><p>Regards</p><p><variable>learnerCorrespondenceName</variable> </p>',
        group: 'learner'
    },
    vslLearnerInvite: {
        templateKey: 'VSL',
        label: 'VSL Learner Invite',
        isDLRQ: false,
        subject: 'Test for your enrolment at <variable>displayName</variable> ',
        body: '<p>Dear <variable>learnerFirstName</variable>,</p><p>As part of your course enrolment at <variable>displayName</variable> we would like you to complete a short online test so we can determine your eligibility for VET Student Loan funding.</p><p>Please click on the link below to start the online test:</p><p><variable>linkToQuiz</variable> </p><p>If the above link does not work please copy and paste this URL into your Internet browser: <variable>plainLinkToQuiz</variable> </p><p>Note: Please access the test using the latest version of Google Chrome.</p><p>If you have any questions please email <variable>learnerCorrespondenceEmail</variable> and someone will respond as soon as possible.</p><p>Regards</p><p><variable>learnerCorrespondenceName</variable> </p>',
        group: 'learner'
    },
    quizReminder: {
        templateKey: 'REMINDER',
        label: 'Quiz Reminder',
        isDLRQ: false,
        body: '<p>Dear <variable>learnerFirstName</variable>,</p><p>Your pre-training LLN Quiz for <variable>displayName</variable> is still yet to be completed.</p><p>Please click on the link below to complete the online test:</p><p><variable>linkToQuiz</variable> </p><p>If the above link does not work please copy and paste this URL into your Internet browser: <variable>plainLinkToQuiz</variable> </p><p>Note: Please access the test using the latest version of Google Chrome.</p><p>If you have any questions please email <variable>learnerCorrespondenceEmail</variable> and someone will respond as soon as possible.</p><p>Regards</p><p><variable>learnerCorrespondenceName</variable> </p>',
        subject: 'REMINDER: complete your test for <variable>displayName</variable> ',
        group: 'learner'
    },
    loginOtpLLNV2: {
        templateKey: 'userLoginOtpLLN',
        label: 'Login OTP',
        body: '<p>Hello <variable>userFirstName</variable>,</p><p>Your One Time password is:</p><h1 style="text-align: center;"><strong><variable>userLoginOtp</variable></strong></h1><p>This code is valid for 30 minutes.</p><p>If you have any questions about your account please contact your system administrator at <variable>adminCorrespondenceEmail</variable>.</p><p>Thanks,</p><p>The LLN Robot System team.</p><p>Note: Please do not respond to this email.</p>',
        subject: 'LLN Robot One Time Passcode',
        group: 'rto'
    },
    userPasswordResetRequestV2: {
        templateKey: 'userPasswordResetRequest',
        label: 'Password Reset Request',
        body: "<p>Hello <variable>userFirstName</variable>,</p><p>We have received a request to reset your <variable>adminCorrespondenceName</variable> LLN Robot System password.</p><p>To reset your password, please click the button below (link expires in 24 hours):</p> <p><variable>userPasswordResetLinkClickable</variable></p><p>If the button above does not work, <b>copy and paste</b> this link into your browser:</p> <p><variable>userPasswordResetLink</variable></p> <hr/><p>If you don't want to change your password or you didn't request this reset, you can ignore this email.</p><p>If you have any questions about your account please contact your system administrator at <variable>adminCorrespondenceEmail</variable>.</p><p>Thanks,<br/>The LLN Robot System team.</p><p>Note: Please do not respond to this email.</p>",
        subject: 'Password Reset Request for your LLN Robot System Account',
        group: 'rto'
    },
    changePasswordLLNV2: {
        templateKey: 'userChangePassword',
        label: 'Success Change Password',
        body: '<p>Hello <variable>userFirstName</variable>,</p><p>Your have successfully change your password.</p><p></p><p>If you have any questions about your account please contact your system administrator at <variable>adminCorrespondenceEmail</variable>.</p><p>Thanks,<br/>The LLN Robot System team.</p><p>Note: Please do not respond to this email.</p>',
        subject: 'Success Change Password LLN Robot',
        group: 'rto'
    },
    learnerDeletedLLN: {
        templateKey: 'learnerDeleted',
        label: 'Deleted Learner',
        body: '<p>Please note that the following completed learner records have been deleted from LLN Robot:</p><p><variable>learnerlistNameLearnerId</variable></p><p>Learner details are retained and can be restored for 30 days, after which they will be removed permanently.</p>',
        subject: 'Learner Deleted from LLN Robot System',
        group: 'rto'
    },
    userInviteV2: {
        templateKey: 'userInvite',
        label: 'User Invite',
        body: '<p>Hello <variable>userFirstName</variable>,</p><p>You have been registered for an account at <variable>llnRobotLoginUrl</variable>.</p><p>To activate your account, please click this <variable>userPasswordCreateLinkClickable</variable>. You will be prompted to set your own password.</p><p>If you have any questions about your account please contact your system administrator at <variable>adminCorrespondenceEmail</variable>. You can also find help documentation here: <variable>accessingLLNRobotDocLink</variable></p><p>You can find an overview of what the LLN Robot System can do here: <variable>llnRobotOverviewLink</variable></p><p>Thanks,<br/>The LLN Robot System team.</p><br/><p>Note: Please do not respond to this email.</p>',
        subject: 'Welcome to the LLN Robot System',
        group: 'rto'
    },
    dailySummaryV2: {
        templateKey: 'dailySummary',
        label: 'Daily Summary',
        body: '<p>Hi <variable>inviterOrAdminCorrespondenceEmail</variable>,<br>Please be advised that in the last 24 hours the following learners that you invited have completed their quiz.</p><p><variable>learnerlistLearnerIdNameEmail</variable><p>To view their results please log in to your LLN Robot System here:<br/><variable>llnRobotLoginUrl</variable></p><p>Kind Regards,<br> <variable>adminCorrespondenceName</variable></p>',
        subject: 'Online LLN Quiz Completion Digest',
        group: 'rto'
    },
    completionEmail: {
        templateKey: 'completionEmail',
        label: 'Learner Quiz Completion Email',
        body: '<p>Hi <variable>adminCorrespondenceName</variable>,</p><p>Please be advised that <variable>learnerFirstName</variable> <variable>learnerLastName</variable> has recently completed the <variable>learnerQuizType</variable>.</p><p>To view their results please log in to your LLN Robot System here:</p> <p><variable>llnRobotLoginUrl</variable></p>Thank you,<br />The LLN Robot System Team<p><variable>completionLogoImg</variable></p>',
        subject: 'Learner has completed the Online LLN Quiz',
        group: 'rto',
        hideHeaderLogo: true
    },
    learnerPreEnrollment: {
        templateKey: 'learnerPreEnrollment',
        label: 'LLN Quiz Profile Report',
        body: '<p>Hi <variable>learnerFirstName</variable>,</p><p>Thank you for completing your LLN assessment.</p><p>Your full LLN Profile Report is now available and has been attached to this email.</p> <p>The attached report includes the following:</p><p><ul><li>A summary of your core skill levels</li><li>A comparison of your results to the course profile</li><li>Potential support options if any skill gaps are identified</li><li>Answers to common questions regarding LLN results andenrolment decisions</li></ul></p><p>If you have any questions or would like to discuss your results, feel free to reach us at <variable>learnerCorrespondenceEmail</variable>.</p>Best regards,<br /><variable>displayName</variable><p>',
        subject: 'LLN Quiz Learner Report',
        group: 'learner',
        customHeader:
            '<p><div style="display:flex; justify-content:center"><h2 style="style="margin: 0; color: #2c3e50">LLN Profile Result</h2></p></div>'
    }
};

export const EMAIL_TEMPLATE_VARIABLES = [
    {
        id: 'learnerFirstName',
        label: 'Learner First Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['ACSF', 'VSL', 'REMINDER', 'completionEmail'],
        groups: ['learner', 'rto']
    },
    {
        id: 'learnerLastName',
        label: 'Learner Last Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['ACSF', 'VSL', 'REMINDER', 'completionEmail'],
        groups: ['learner', 'rto']
    },
    {
        id: 'linkToQuiz',
        label: 'Quiz Link (Clickable)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['All'],
        groups: 'learner'
    },
    {
        id: 'plainLinkToQuiz',
        label: 'Quiz Link (Plain Text)',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['learner']
    },
    {
        id: 'displayName',
        label: 'Company Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['learner']
    },
    {
        id: 'learnerCorrespondenceName',
        label: 'Learner Correspondence Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['learner']
    },
    {
        id: 'learnerCorrespondencePhone',
        label: 'Learner Correspondence Phone',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['learner']
    },
    {
        id: 'learnerCorrespondenceEmail',
        label: 'Learner Correspondence Email',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['learner']
    },
    {
        id: 'userFirstName',
        label: 'User First Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['rto']
    },
    {
        id: 'userLoginOtp',
        label: 'OTP',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['userLoginOtpLLN'],
        groups: ['rto']
    },
    {
        id: 'adminCorrespondenceEmail',
        label: 'Admin Correspondence Email',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['rto']
    },
    {
        id: 'adminCorrespondenceName',
        label: 'Admin Correspondence Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['rto']
    },
    {
        id: 'userPasswordResetLink',
        label: 'Password Reset Link',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userPasswordResetRequest'],
        groups: ['rto']
    },
    {
        id: 'userPasswordResetLinkClickable',
        label: 'Reset Password (Clickable)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userPasswordResetRequest'],
        groups: ['rto']
    },
    {
        id: 'learnerlistNameLearnerId',
        label: 'Learner List (Name, Learner Id)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['learnerDeleted'],
        groups: ['rto']
    },
    {
        id: 'userPasswordCreateLinkClickable',
        label: 'Create Password (Clickable)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userInvite'],
        groups: ['rto']
    },
    {
        id: 'accessingLLNRobotDocLink',
        label: 'Accessing LLN Robot Link',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userInvite'],
        groups: ['rto']
    },
    {
        id: 'llnRobotOverviewLink',
        label: 'LLN Robot Overview Link',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userInvite'],
        groups: ['rto']
    },
    {
        id: 'inviterOrAdminCorrespondenceEmail',
        label: 'Inviter Name Or Admin Correspondence Name',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['dailySummary'],
        groups: ['rto']
    },
    {
        id: 'learnerlistLearnerIdNameEmail',
        label: 'Learner List (Learner ID, Name, Email)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['dailySummary'],
        groups: ['rto']
    },
    {
        id: 'llnRobotLoginUrl',
        label: 'LLN Robot Login Url',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['All'],
        groups: ['rto']
    },
    {
        id: 'learnerQuizType',
        label: 'Learner Quiz Type',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['completionEmail'],
        groups: ['rto']
    },
    {
        id: 'completionLogoImg',
        label: 'Completion Logo Image',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['completionEmail'],
        groups: ['rto']
    }
];

/**
 * Store All static links/url
 */
export const STATIC_LINKS = {
    axcelarateSupport: 'https://support.lln.training/article/440-axcelerate-integration-setup',
    apiSupport: 'https://support.lln.training/category/441-student-management-system-sms-integrations',
    wisenetSupport: 'https://support.lln.training/article/558-wisenet-integration',
    webhookSupport: 'https://support.lln.training/webhooks',
    wisenetTestingCallbackUri: 'https://canary-api.lln.training/wn/callback'
};

export const WISENET_AUTHENTICATE = {
    codeChallenge: process.env.REACT_APP_WISENET_CODE_CHALLENGE,
    redirectUri: process.env.REACT_APP_WISENET_REDIRECT_URI,
    clientId: process.env.REACT_APP_WISENET_CLIENT_ID,
    clientSecret: process.env.REACT_APP_WISENET_CLIENT_SECRET,
    challengeMethod: process.env.REACT_APP_WISENET_CHALLENGE_METHOD,
    url: process.env.REACT_APP_WISENET_URI
};

export const DEFAULT_TABLE_BODY_ROW = {
    infos: [
        {
            list: [
                {
                    height: 25
                }
            ]
        }
    ]
};

export const DEFAULT_LOGO_URL = 'https://s3.ap-southeast-2.amazonaws.com/static.lln.training/clients/tlrg-online/client-logo.png';

export const IMG_LOGO_SIZE = {
    xs: {
        width: 400,
        height: 200
    },
    sm: {
        width: 470,
        height: 230
    },
    md: {
        width: 650,
        height: 250
    },
    lg: {
        width: 680,
        height: 280
    },
    xl: {
        width: 700,
        height: 300
    }
};
